import { TableColumn } from '@/classes'

const UserListColumns = [
  new TableColumn('Username', 'username', true, 'asc', 'left'),
  new TableColumn('FullName', 'fullName', true, 'asc', 'left'),
  new TableColumn('Active', 'active', true, 'desc', 'centered'),
  new TableColumn('', 'action', false, 'desc', 'centered')
]

export { UserListColumns }